import { __awaiter } from "tslib";
import { useAemConfig } from '@as-react/common-components';
import { CookieConsentGroups } from '@as-react/common-types';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { makeGetCookieConsentSettings } from '../redux/cookieConsent/selectors/CookieConsentSelector';
import scriptLoaderUtil from '../util/ScriptLoaderUtil';
/* eslint-enable @typescript-eslint/no-namespace */
const SCRIPT_ID = 'reevoo-loader';
export const useReevoo = (shouldLoad = true) => {
    const { review: { reevooAccountCode, reevoo: reevooEnabled }, } = useAemConfig();
    const cookieConsentSettings = useSelector(makeGetCookieConsentSettings());
    const [isLoaded, setLoaded] = useState(false);
    const loadReevooScript = () => __awaiter(void 0, void 0, void 0, function* () {
        let attributes = {};
        if (!cookieConsentSettings) {
            attributes = { 'disable-cookie': 'all' };
        }
        else if (cookieConsentSettings[CookieConsentGroups.FUNCTIONAL] &&
            !cookieConsentSettings[CookieConsentGroups.ANALYTICS]) {
            attributes = { 'disable-cookie': 'performance' };
        }
        try {
            yield scriptLoaderUtil.loadScript(`https://widgets.reevoo.com/loader/${reevooAccountCode}.js`, SCRIPT_ID, false, attributes, document.head);
            setLoaded(true);
            window.isReevooScriptLoaded = true;
        }
        catch (_a) { }
    });
    useEffect(() => {
        if (reevooEnabled && shouldLoad) {
            loadReevooScript();
        }
    }, [shouldLoad]);
    return isLoaded;
};
